import { TablePaginationContext } from '@/components';
import { PagedTable } from '@/components/PagedTable/PagedTable';
import { useGetEmployeesByCompany } from '@/modules/Users/queries';
import { useEmployeesColumns } from '@/shared/hooks/useEmployeesColumns';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

type CompanyEmployeesTabProps = {
  companyId: number;
};
export const CompanyEmployeesTab = ({
  companyId,
}: CompanyEmployeesTabProps) => {
  const { t } = useTranslation();
  const { page, searchTerm, tableSort } = useContext(TablePaginationContext);

  const sort = tableSort[0];

  const { data: employees, isLoading } = useGetEmployeesByCompany({
    companyId,
    pageNumber: page,
    filter: searchTerm,
    sortBy: sort?.columnId,
    sortOrder: sort?.direction,
  });

  const columns = useEmployeesColumns();

  return (
    <PagedTable
      title={t('employees')}
      columns={columns}
      page={employees}
      isLoading={isLoading}
      emptyStateMessage={t('no_employees_available')}
    />
  );
};
